import { ParagraphElement } from 'components/plate-ui/paragraph-element';
import { ParagraphPlugin } from 'platejs/react';

export const BasicBlocksKit = [ParagraphPlugin.withComponent(ParagraphElement)];
